import type { FormValues } from '../types';

export const DEFAULT_FORM_VALUES: FormValues = {
  include_basic_information: false,
  include_basic_information_first_name: false,
  include_basic_information_middle_name: false,
  include_basic_information_last_name: false,
  include_basic_information_primary_email: false,
  include_basic_information_date_of_birth: false,
  include_basic_information_phone: false,
  include_basic_information_gender: false,
  include_basic_information_home_airports: false,
  include_basic_information_age: false,
  include_basic_information_relationship_to_primary: false,
  include_address: false,
  include_address_mailing: false,
  include_address_billing: false,
  group_view_preferences_allergies: false,
  group_view_comfort_related: false,
  include_allergies_dietary_restrictions: false,
  include_important_dates: false,
  include_important_dates_date_of_birth: false,
  include_important_dates_confirmation_ceremony: false,
  include_loyalty_programs: false,
  include_loyalty_program_full_name: false,
  include_loyalty_program_program: false,
  include_loyalty_program_number: false,
  include_important_travel_data: false,
  include_important_travel_data_global_entry_number: false,
  include_important_travel_data_known_traveler_number: false,
  include_emergency_contact: false,
  include_flight_preferences: false,
  include_travel_preferences_by_category: false,
  include_travel_preferences_by_category_travel: false,
  include_travel_preferences_by_category_lifestyle: false,
  include_travel_preferences_by_category_stay: false,
  include_travel_preferences_by_category_personal: false,
  include_related_contacts: false,
  include_notes: false,
  include_tasks: false,
  include_client_documents: false,
  include_passport_details: false,
  include_passport_details_passport_number: false,
  include_passport_details_document_date_of_birth: false,
  include_passport_details_expiry_date: false,
  include_comfort_related_full_name: false,
  include_comfort_related_height: false,
  include_comfort_related_weight: false,
  include_comfort_related_details: false,
  include_passport_files_as_separate_pdfs: false,
};
